<template>
    <loading-spinner v-if="isLoading"></loading-spinner>
    <div v-else>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">사용자 매뉴얼</span>
            <span class="txt">센터 admin에 보여질 사용자 매뉴얼 게시글을 작성 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!manualDetail"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/manual/list">목록</router-link>
                    <router-link v-if="careAuth === true" :to="`/madmin/manual/edit/${id}`" class="com-btn blue">
                        수정
                    </router-link>
                    <button v-if="careAuth === true" class="com-btn red" @click="deleteManual(id)">삭제</button>
                </div>
            </div>
            <table class="com-table view">
                <colgroup>
                    <col style="width: 170px" />
                    <col style="width: auto" />
                    <col style="width: 170px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td>{{ manualDetail.boardCategory === null ? '' : manualDetail.boardCategory.name }}</td>
                        <th>글쓴이</th>
                        <td>
                            {{
                                manualDetail.info.createdName === 'root@root.com'
                                    ? '핏투데이케어'
                                    : manualDetail.info.createdName
                            }}
                        </td>
                    </tr>
                    <tr>
                        <th>조회수</th>
                        <td>{{ manualDetail.viewCount }}</td>
                        <th>등록일</th>
                        <td>{{ manualDetail.info.createdAt | timestampFilter }}</td>
                    </tr>
                    <tr>
                        <th>첨부파일</th>
                        <td colspan="3">
                            <a
                                v-for="(file, index) in fileList"
                                :key="index"
                                :href="file.fileUrl"
                                class="file-down"
                                style="cursor: pointer"
                            >
                                {{ file.name }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td colspan="3">{{ manualDetail.title }}</td>
                    </tr>
                    <tr>
                        <td class="no-padding no-side-border" colspan="4">
                            <div class="txt-view">
                                <div v-html="manualDetail.content"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/manual/list">목록</router-link>
                    <router-link v-if="careAuth === true" :to="`/madmin/manual/edit/${id}`" class="com-btn blue">
                        수정
                    </router-link>
                    <button v-if="careAuth === true" class="com-btn red" @click="deleteManual(id)">삭제</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'manualDetail',
    components: { LoadingSpinner },
    props: {},
    computed: {
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            // 케어 권한 확인
            this.careAuth = true;
        }
        this.fetchManualDetail();
    },
    data() {
        return {
            careAuth: false,
            isLoading: false,
            id: this.$route.params.id,
            manualDetail: null,
            fileList: null,
        };
    },
    methods: {
        // 사용자 매뉴얼 상세 Fetch
        async fetchManualDetail() {
            try {
                const { data } = await this.getManualDetail(this.id);
                this.manualDetail = data;

                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.getManualDetailFileGroup(data.fileGroupId);
                    this.fileList = fileGroupData.data;
                }

                console.log('===> Success Loading Manual Detail', data);
            } catch (error) {
                console.log(error);
            }
        },

        // 사용자 매뉴얼 삭제
        async deleteManual(id) {
            try {
                this.isLoading = true;
                const { data } = await this.getDeleteManual(id);
                alert('사용자 매뉴얼을 삭제했습니다.');
                this.isLoading = false;
                console.log('===> Success Delete Manual', data);
                this.$router.push({ name: 'manualList' });
            } catch (error) {
                console.log(error);
            }
        },

        // 사용자 매뉴얼 상세 API
        getManualDetail(id) {
            return api.get(`/admin/api/board/manual-qa/${this.id}/view`);
        },

        // 사용자 매뉴얼 상세 첨부 파일 리스트 API
        getManualDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 사용자 매뉴얼 삭제 API
        getDeleteManual(id) {
            return api.delete(`/admin/api/board/manual-qa/${id}`);
        },

        // a 태그 파일 다운로드 이벤트
        fileDownload(url) {
            api.post(url, {
                responseType: 'blob',
            })
                .then(function (response) {
                    let blob = new Blob([response.data], { type: 'image/png' });

                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ');
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
<style scoped src="@/assets/js/ckeditor/ckeditor.css"></style>
<!-- ckeditor5 css -->
<style lang="scss"></style>
